var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueTick = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 58,
  height: 58,
  viewBox: "0 0 58 58",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29 58C45.0163 58 58 45.0163 58 29C58 12.9837 45.0163 0 29 0C12.9837 0 0 12.9837 0 29C0 45.0163 12.9837 58 29 58Z",
  fill: "#00B0CA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6094 29.5142L23.3583 36.5439C23.658 37.0105 24.1556 37.2973 24.6942 37.3141C25.2327 37.3309 25.7459 37.0755 26.0718 36.6284L40.1177 21.708",
  stroke: "#F2F4F7",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/blue-tick.7e4ab56519968c9844f9331dcb9e4d6e.svg";